import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { getLanguagePack, getNestedValue, DEFAULT_LANGUAGE } from '../locales';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // 로컬 스토리지에서 언어 설정 불러오기
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || DEFAULT_LANGUAGE;
  });

  const [translations, setTranslations] = useState(() => getLanguagePack(language));

  // 언어 변경 함수
  const setLanguage = useCallback((languageCode) => {
    setLanguageState(languageCode);
    setTranslations(getLanguagePack(languageCode));
    localStorage.setItem('language', languageCode);
  }, []);

  // 번역 함수
  const t = useCallback((key, fallback = '') => {
    const value = getNestedValue(translations, key);
    return value !== key ? value : fallback || key;
  }, [translations]);

  // 언어 변경 시 translations 업데이트
  useEffect(() => {
    setTranslations(getLanguagePack(language));
  }, [language]);

  const value = {
    language,
    setLanguage,
    t,
    translations,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;

